import script from "./index.vue?vue&type=script&setup=true&name=login&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=login&lang=js"

import "./index.vue?vue&type=style&index=0&id=1d9e3742&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d9e3742"]])

export default __exports__